export default defineNuxtRouteMiddleware(async (to) => {
  // skip middleware on server
  if (import.meta.server) return

  const {accessToken} = useAuthStore();
  const unguardedRoutes = ['/auth/login', '/auth/register'];

  if(!accessToken && !unguardedRoutes.includes(to.fullPath)) {
    return navigateTo('/auth/login');
  }

});
